import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

interface ReportParams {
	groupId?: string;
}

interface UseGenerateTagReportMutationOptions {
	onSuccess?: () => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
	impersonationContext?: Api.IImpersonationContext;
}

export function useGenerateTagReportMutation({
	onSuccess,
	onError,
	impersonationContext,
}: UseGenerateTagReportMutationOptions) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: async (params: ReportParams) => {
			return userSession.webServiceHelper.callAsync<Api.ISystemJob>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'reports/tagOwner/run',
				}),
				'POST',
				params
			);
		},
		onSuccess,
		onError,
	});
}
